<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <!--<div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"  @click="$router.push('/sale-add')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>-->
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{
                operationsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize :
                operationsData.length }} of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
          @input="updateSearchQuery" placeholder="Search..." />
        <vs-button v-if="displayExport != false" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as
          CSV</vs-button>
        <!--<vs-button class="btn-drop ml-2" color="#c0c0c0" icon-pack="feather" icon="icon-download"
          @click="downloadSaga()">Export SAGA (previous month)</vs-button>-->


        <!-- ACTION - DROPDOWN -->
        <!--
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
-->
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="operationsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
        :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true" :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from "moment";
import axios from "axios";
// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      displayExport: false,
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'INV. NR.',
          valueGetter: function (params) {
            return params.data.invoice_no
          },
          //field: 'iscompany',
          filter: true,
          width: 135,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'STATUS',
          valueGetter: function (params) {
            if (params.data.isactive == true) {
              if (params.data.status == 'Paid') return "Paid"
              else return "Pending Payment"
            }
            else {
              if (params.data.status == 'Paid') return "Major Issue!"
              else return "Inactive"
            }
          },
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'TYPE',
          valueGetter: function (params) {
            if (params.data.isadvanceinvoice) return "Advance Invoice"
            else if (params.data.iscreditnote) return "Credit Note"
            else return "Final Invoice"
          },
          //field: 'iscompany',
          filter: true,
          width: 170,
        },
        {
          headerName: 'QUOTATION',
          valueGetter: function (params) {
            return params.data.quotation_no != null && params.data.quotation_no !== '' ? "REF. #" + params.data.quotation_no : "-"
          },
          //field: 'iscompany',
          filter: true,
          width: 140,
        },
        {
          headerName: 'DATE',
          valueGetter: function (params) {
            return params.data.creation
          },
          //field: 'iscompany',
          filter: true,
          sort: 'DESC',
          width: 160
        },
        /*{
          headerName: 'PAYMENT',
          valueGetter: function(params) {
            return params.data.status
          },
          //field: 'iscompany',
          filter: true,
          width: 160,
          cellRendererFramework: 'CellRendererStatus'
        },*/
        {
          headerName: 'CLIENT',
          field: 'client',
          filter: true,
          width: 250
        },
        {
          headerName: 'VOL. (m3)',
          valueGetter: function (params) {
            if (parseFloat(params.data.volume) === 1 || params.data.isadvanceinvoice) return "N/A"
            else return Math.abs(params.data.volume).toFixed(1).toLocaleString()
          },
          filter: true,
          width: 120
        }, {
          headerName: 'PRICE (EUR)',
          valueGetter: function (params) {
            if (params.data.invoice_no && params.data.price && params.data.invoice_no.startsWith('EU')) {
              return parseFloat(params.data.price).toFixed(2).toLocaleString();
            } else {
              return "N/A";
            }
          },
          filter: true,
          width: 138,
          type: 'numericColumn'
        },
        {
          headerName: 'PRICE (RON)',
          valueGetter: function (params) {
            if (params.data.priceron && params.data.invoice_no.startsWith('RO')) {
              return parseFloat(params.data.priceron).toFixed(2).toLocaleString();
            } else {
              return "N/A";
            }
          },
          filter: true,
          width: 141,
          type: 'numericColumn'
        },
        {
          headerName: 'BROKER',
          field: 'broker',
          filter: true,
          width: 138
        },
        {
          headerName: "COUNTRY",
          field: "delivery_country",
          filter: true,
          width: 120,
        },
        {
          headerName: "FSC",
          valueGetter: function (params) {
            return params.data.isfsc_quotation ? "FSC" : "-"
          },
          filter: true,
          width: 90,
        },
        {
          headerName: "TENURE (months)",
          valueGetter: function (params) {
            return params.data.months_since_first_final_invoice ? params.data.months_since_first_final_invoice : "-"
          },
          filter: true,
          width: 90,
        },


        {
          headerName: 'BOTTOM',
          valueGetter: function (params) {
            return params.data.bottom
          },
          filter: true,
          width: 0,
          hide: true  // This will hide the column
        },
        {
          // Same column as the production list. true = in SAGA (SagaX1n, or the
          // old SagaX1): its customer, date, number, lines and VAT are locked.
          headerName: 'Sync Saga',
          valueGetter: function (params) {
            if (params.data.issyncsaga) return params.data.issyncsaga
            else return false
          },
          field: 'Sync Saga',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'ACTIONS',
          field: 'transactions',
          width: 110,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    operationsData() {
      return this.$store.state.operationList.operations
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 100
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    downloadSaga() {
      // Notification pour le démarrage de la génération
      this.$vs.notify({
        title: "Generating...",
        text: "Generating XML in a suitable format...",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary",
        position: "bottom-right",
        time:8000,
      });

      setTimeout(() => {
        // Notification pour la compression
        this.$vs.notify({
          title: "Compressing and downloading...",
          text: "Compressing into a ZIP file...",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "primary",
          position: "bottom-right",
          time: 12000,
        });

        // Création et déclenchement du lien pour le téléchargement
        const link = document.createElement("a");
        link.href = "https://xylo.codesinn.com/api/saga/download";
        link.download = "Invoices.zip"; // Nom du fichier (optionnel)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // ATTENTION : rien ici ne verifie que le ZIP a ete produit ni recu.
        // Le lien est un <a> nu ; un 500 sur /api/saga/download affichait
        // exactement le meme « Success! ». On annonce donc le DEPART de la
        // demande, pas sa reussite.
        setTimeout(() => {
          this.$vs.notify({
            title: "Download started",
            text: "If no ZIP file appears in your downloads, the export failed - check with the developer.",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "warning",
            position: "bottom-right",
            time: 8000,
          });
        }, 4000); // Délai pour laisser le temps au téléchargement de démarrer
      }, 8000); // Délai pour afficher la deuxième notification après la première
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    this.$vs.loading()
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.$store.dispatch('operationList/fetchSales')
      .then(response => {
        this.$vs.loading.close()
      })
      .catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
